module.exports = __webpack_public_path__ + "static/media/Mediterranee.50402d85.jpg";